module.exports = __webpack_public_path__ + "img/positive-div.04f9111b.svg";